import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  recentProductSearches: [],
};

const mapRecentSearches = (recentProductSearches, payload) => {
  return [payload, ...recentProductSearches.filter((v) => v !== payload)].slice(0, 5);
};

const recentProductSearch = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.RECENT_PRODUCT_SEARCH_ADD:
      return {
        ...state,
        recentProductSearches: mapRecentSearches(state.recentProductSearches, payload),
      };
    case actions.RECENT_PRODUCT_SEARCH_CLEAR:
      return {
        recentProductSearches: [],
      };
    default:
      return state;
  }
};

export default recentProductSearch;
